import React from 'react';
import { useTheme } from '@mui/material';

const EquivalencyStrip = ({ totalCarbon, equivalencyMode, setEquivalencyMode }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
    const trees = Math.round(totalCarbon / 25);
    const carMiles = Math.round(totalCarbon / 0.19);

    return (
        <div style={{
            marginTop: '20px',
            background: isDark ? 'linear-gradient(135deg, #1c1c1e 0%, #27272a 100%)' : 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
            borderRadius: '16px',
            padding: '16px 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            border: `1px solid ${isDark ? '#3f3f46' : '#e2e8f0'}`,
            width: '100%'
        }}>
            <div style={{ flex: 1 }}>
                <div style={{ fontSize: '10px', fontWeight: 600, color: '#64748b', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Real-World Impact</div>
                {equivalencyMode === 'trees' ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ fontSize: '28px' }}>🌳</div>
                        <div>
                            <div style={{ fontSize: '11px', color: '#64748b', marginBottom: '1px' }}>To offset this building's carbon:</div>
                            <div style={{ fontSize: '18px', fontWeight: 700, color: '#10b981' }}>
                                {trees.toLocaleString()} Trees
                            </div>
                        </div>
                    </div>
                ) : (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ fontSize: '28px' }}>🚗</div>
                        <div>
                            <div style={{ fontSize: '11px', color: '#64748b', marginBottom: '1px' }}>Equivalent to driving:</div>
                            <div style={{ fontSize: '18px', fontWeight: 700, color: '#ef4444' }}>
                                {carMiles.toLocaleString()} Miles
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <button
                onClick={() => setEquivalencyMode(prev => prev === 'trees' ? 'cars' : 'trees')}
                style={{
                    padding: '8px 16px',
                    background: isDark ? '#27272a' : 'white',
                    border: `1px solid ${isDark ? '#3f3f46' : '#e2e8f0'}`,
                    borderRadius: '8px',
                    fontSize: '11px',
                    fontWeight: 600,
                    color: isDark ? '#f1f5f9' : '#475569',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                }}
                onMouseEnter={(e) => {
                    e.target.style.background = isDark ? '#3f3f46' : '#f8fafc';
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.boxShadow = '0 4px 6px rgba(0,0,0,0.2)';
                }}
                onMouseLeave={(e) => {
                    e.target.style.background = isDark ? '#27272a' : 'white';
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)';
                }}
            >
                {equivalencyMode === 'trees' ? '🚗 Show Car Miles' : '🌳 Show Trees'}
            </button>
        </div>
    );
};

export default EquivalencyStrip;
